<div class="channels">
  <div class="channels__headers" id="channelsHeaders" *hasWorkspaceFeature="[WorkspaceFeatures.canUseFilters]">
    <div class="channels__headers__search">
      <ngx-channels-list-search
        [phoneNumber]="phoneNumber"
        class="channels__headers__search__input"
        *hasWorkspaceFeature="[WorkspaceFeatures.canUseSearchFilter]"></ngx-channels-list-search>
    </div>
    @if (showFilters()) {
    <ngx-channels-list-filters></ngx-channels-list-filters>
    }
  </div>
  <ngx-channels-list></ngx-channels-list>
</div>
